<app-loading-spinner [size]="48" [strokeWidth]="4" />

<p class="body mt-16">{{ data?.message || 'Almost there – this should only take a few seconds…' }}</p>
